export default "__VITE_ASSET__db62b17b__"